import {
  Fab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from '@material-ui/core';
import React from 'react';
import {Clear, Delete} from '@material-ui/icons';
import propTypes from 'prop-types';
import {
  FILL_COLOR,
  TEXT_COLOR,
  assetsTableStylesObject,
  convertCamelCaseToWords,
  formatTimeStamp,
} from '../../helpers/tools';

const useStyles = makeStyles(() => ({
  ...assetsTableStylesObject,
  assetThumbnail: {
    border: '1px solid white',
    '&:hover': {
      transform: 'scale(2.2)',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
      transition: 'all .2s ease-in-out',
    },
  },
  table: {
    width: 'auto',
    overflowX: 'auto',
    marginLeft: 15,
    marginTop: 5,
  },
  tableHead: {
    backgroundColor: FILL_COLOR,
    color: TEXT_COLOR,
  },
}));

const PackagesTable = ({packages, asset, isUpdating, ruidsToDelete, onDeleteDP}) => {
  const classes = useStyles();

  if (packages?.length) {
    const header = Object.keys(packages[0]);
    const timeStampProperties = ['startDate', 'endDate'];
    return (
      <TableContainer className={classes.table} component={Paper}>
        <Table aria-label="a dense table" size="small">
          <TableHead>
            <TableRow>
              {/* Adds extra space to accommodate delete check buttons when updating */}
              {asset?.dataPackages && isUpdating ? <TableCell /> : null}
              {header.map((h, i) => (
                // removes classes that show a "disabled" table when updating
                <TableCell className={classes.tableHead} key={i}>
                  {convertCamelCaseToWords(h)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {packages.map((row, index) => (
              <TableRow key={index}>
                {isUpdating && (
                  <TableCell>
                    <DeleteDataPackageBtn
                      asset={asset}
                      handleClick={onDeleteDP}
                      row={row}
                      ruidsToDelete={ruidsToDelete}
                    />
                  </TableCell>
                )}
                {header.map((h, i) => (
                  <TableCell key={i}>
                    {row && row[h]
                      ? timeStampProperties.includes(h)
                        ? formatTimeStamp(row[h])
                        : row[h].toString()
                      : null}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
  return null;
};

const DeleteDataPackageBtn = ({row, handleClick, ruidsToDelete}) => {
  const classes = useStyles();
  const selected = ruidsToDelete.find(ruid => row.dataPackageId === ruid);

  return (
    <Fab
      className={classes.margin}
      color={selected ? 'primary' : 'secondary'}
      size="small"
      title={`${selected ? 'Unc' : 'C'}heck Data Package ${row.dataPackageId} for deletion`}
      onClick={() => handleClick(row)}
    >
      {selected ? <Clear fontSize="small" size="small" /> : <Delete fontSize="small" size="small" />}
    </Fab>
  );
};

DeleteDataPackageBtn.propTypes = {
  handleClick: propTypes.func,
  row: propTypes.number,
  ruidsToDelete: propTypes.array,
};

export default PackagesTable;

PackagesTable.propTypes = {
  asset: propTypes.object,
  isUpdating: propTypes.bool,
  onDeleteDP: propTypes.func,
  packages: propTypes.array,
  ruidsToDelete: propTypes.array,
};
